<div class="page gray-font-color font-family">
  <div class="header-navigation-back" >
    <div class="back-icon" (click)="backAction()" fxFlex="5"><mat-icon svgIcon="left-arrow"></mat-icon></div>
    <div  class="header-text">Uploaded Document</div>
  </div>
  <div class="content" >
    <div  >
      <div class="document-list-item">
        <div class="document-row">
          <div  class="file-name" data-testid="fileName">
            {{ fileName }}
          </div>
          <div class="document-actions">
            <mat-icon class="open-icon" (click)="onDownloadFileClick(selectedId)" data-testid="openBtn" title="Open in new tab">open_in_new</mat-icon>
            <mat-icon
              svgIcon="delete-icon"
              class="delete-icon"
              (click)="deleteDocument(selectedId)"
              data-testid="deleteBtn"
            ></mat-icon>
          </div>
        </div>
        <mat-divider></mat-divider>

        <!-- Inline Document Preview -->
        <div class="document-preview-section">
          @if (previewLoading) {
            <div class="preview-loading">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          }
          @if (!previewLoading && previewImageUrl) {
            <img [src]="previewImageUrl" class="preview-image" alt="Document preview" data-testid="previewImage" />
          }
          @if (!previewLoading && previewPdfUrl) {
            <iframe [src]="previewPdfUrl" class="preview-pdf" frameborder="0" loading="lazy" data-testid="previewPdf"></iframe>
          }
        </div>

        <mat-divider></mat-divider>
        @if (!issueDate && selectedType !== 'PRCard' && selectedType !== 'HealthCard' && generatedDate) {
          <div class="document-row">
            <div  class="date-uploaded-text">Issued Date</div>
            <div  class="date-text">{{ generatedDate | date: 'dd MMM yyyy' }}</div>
          </div>
        }
        @if (showIssueDateFromApi && selectedType !== 'PRCard') {
          <div class="document-row">
            <div class="date-uploaded-text">Issued Date</div>
            <div class="date-text">{{ issueDate | date: 'dd MMM yyyy' }}</div>
          </div>
        }
        <mat-divider></mat-divider>
        @if (expiryDate) {
          <div class="document-row">
            <div  class="date-uploaded-text">Expiry Date</div>
            <div  class="date-text">{{ expiryDate | date: 'dd MMM yyyy' }}</div>
          </div>
        }
        @if (fastCardNumber || healthCardNumber) {
          <mat-divider></mat-divider>
        }
        @if (fastCardNumber) {
          <div class="document-row">
            <div  class="date-uploaded-text">FAST Card Number</div>
            <div  class="date-text">{{ fastCardNumber }}</div>
          </div>
        }
        @if (healthCardNumber) {
          <div class="document-row">
            <div  class="date-uploaded-text">Health Card Number</div>
            <div  class="date-text">{{ healthCardNumber }}</div>
          </div>
        }
        @if (issuingOrganization) {
          <mat-divider></mat-divider>
        }
        @if (issuingOrganization) {
          <div class="document-row">
            <div  class="date-uploaded-text">Issuing Organization</div>
            <div  class="date-text">{{ issuingOrganization }}</div>
          </div>
        }
        @if (credentialId) {
          <mat-divider></mat-divider>
        }
        @if (credentialId) {
          <div class="document-row">
            <div  class="date-uploaded-text">Credential Id</div>
            <div  class="date-text">{{ credentialId }}</div>
          </div>
        }
        @if (credentialUrl) {
          <mat-divider></mat-divider>
        }
        @if (credentialUrl) {
          <div class="document-row">
            <div  class="date-uploaded-text">Credential Url</div>
            <div  class="date-text">{{ credentialUrl }}</div>
          </div>
        }
        <mat-divider></mat-divider>
      </div>
    </div>
  </div>
</div>
